import { defineComponent as _defineComponent } from 'vue'

import Icon from "@/components/widgets/icons/Icon.vue"
import { useTranslation } from "@/i18n/useTranslation"


export default /*#__PURE__*/_defineComponent({
  __name: 'NextSteps',
  emits: ["complete"],
  setup(__props) {



const { t } = useTranslation("Missions/CreateNewProjectNextSteps")

const nextSteps = [
  {
    title: t("projectAssessment"),
    description: t("projectAssessmentDescription"),
  },
  {
    title: t("notification"),
    description: t("notificationDescription"),
  },
  {
    title: t("efficientManagement"),
    description: t("efficientManagementDescription"),
  },
  {
    title: t("support"),
    description: t("supportDescription"),
  },
]

return { __sfc: true,t, nextSteps, Icon }
}

})